const dungeonLevels = `

#### General Overview
Here is an overview of the level requirements for different dungeons:
- **Distorted Space (Parallel World)**: Accessible from level **150**. Requires a **Forged Investigation Permit** from the Black Market Family Nostra.
- **Island of Forgotten Gods**: Accessible from level **160**. Requires a **Shepherd Boarding Pass**, available from the Black Market Family Nostra. Entry is through the ruined city port.

![Dungeon Level Cap](http://arcane-rappelz.com/uploads/dungeon_level_cap.png)

#### Distorted Space
In this dungeon, you must defeat the first boss to unlock the second one, and so on.

![Distorted Space Map](assets/guide/qua7ohou.jpg)

#### Red Spider Circus & Underground Dungeons
- Entry available from **level 150**.
- Only the first **two difficulty stages** can be accessed at level 150.
- From **level 160**, all difficulty levels are available.
- The underground dungeons are found in the first four main dungeons at their **first teleportation point** (e.g., Crystal Valley 1st teleport).
- At level **160**, quests for the underground dungeons become available at the teleporters.

#### Ruins of the Ancients
- Entry is granted **only** after completing part of the **level 170 TP quest** in the ruined city with **Hektor**.
- The **level 170 TP quest** can be accepted at level **160**.
- Once you obtain the **Symbol of the Guard Corps**, you can enter the Ruins of the Ancients.
- The final **TP skill points** are awarded only at level **170**, upon completing the full quest.

#### Devildom
- To access **Devildom**, you must complete the **Kainen quest** on **Lost Island**.
- At **level 175**, return to Lost Island to receive the **entry quest**.

![Devildom Entry](assets/guide/59ekdlmy.jpg)  ![Devildom Entry 2](assets/guide/d6fq877q.jpg)`;

export default dungeonLevels;
